import Cookies from "js-cookie"
import type { Options } from "@kiwicom/frontend-common/services/fetch/jsonFetch"
import jsonFetch from "@kiwicom/frontend-common/services/fetch/jsonFetch"
import sniffError from "@kiwicom/frontend-common/services/utils/sniffError"
import apiBookingTokens from "@kiwicom/frontend-common/services/apiBookingTokens/apiBookingTokens"
import { getAccessToken } from "@kiwicom/nitro/lib/services/auth"
import { isDarwinFeatureOn } from "@kiwicom/frontend-common/services/abTesting/darwinHelper"
import { isTequila } from "@kiwicom/nitro/lib/services/platform/shared"

// @ts-expect-error: Flow to TS migration.
export const apiUrl = (): string => window.reduxStore.getState().options.get("bookingApiUrl")
// TODO: Api should return errors with correct error status, not with status 200
export const fetchWithSniff = (url: string, options: Options) =>
  jsonFetch(url, options).then((body) => {
    const maybeError = sniffError(null, { body })
    if (maybeError) return Promise.reject(maybeError)
    return body
  })

export const HEADER_SIMPLE_TOKEN = "KW-Simple-Token"
export const HEADER_USER_TOKEN = "KW-User-Token"

export async function transport(
  // FIXME: add "@flow" annotation to this file for type checking to work

  method: "POST" | "GET" | "DELETE" | "PATCH" | "PUT",
  // FIXME: add "@flow" annotation to this file for type checking to work

  bid: number | null | undefined,
  // FIXME: add "@flow" annotation to this file for type checking to work

  path: string,
  // FIXME: add "@flow" annotation to this file for type checking to work

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  query: any,
  // FIXME: add "@flow" annotation to this file for type checking to work

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload?: any,
  // FIXME: add "@flow" annotation to this file for type checking to work

  // FIXME: add "@flow" annotation to this file for type checking to work
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  retry: number = 0,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<any> {
  const isMamboApiCall = path.includes("mmb/v1")
  const isPaymentApiCall = path.includes("/payments/v1")
  // @ts-expect-error: Flow to TS migration.
  const { options } = window.reduxStore.getState()
  const fetchUrl = isMamboApiCall ? options.get("mmbApiUrl") : apiUrl()
  const simpleToken = bid ? apiBookingTokens.getSimple(bid) : null
  const isTequilaEnabled = isTequila({ ui: Cookies.get("ui") ?? null })
  const isSkyUsersV2 = Boolean(
    isDarwinFeatureOn("USE_SKYUSERS_V2") || Cookies.get("dev_skyusers_v2_enabled"),
  )
  const userToken = await getAccessToken({ isSkyUsersV2: isTequilaEnabled ? false : isSkyUsersV2 })

  if (isMamboApiCall || isPaymentApiCall) {
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    return fetchWithSniff(fetchUrl + path, {
      headers: {
        [HEADER_SIMPLE_TOKEN]: simpleToken || "",
        // Fix this the next time the file is edited. (Flow to TS)
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        [HEADER_USER_TOKEN]: userToken || "",
      },
      // @ts-expect-error: Flow to TS migration.
      method,
      query,
      body: payload,
      retry,
    })
  }

  const queryPart = {
    brand: options.branding.get("id"),
    ...query,
  } as const

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
  return fetchWithSniff(fetchUrl + path, {
    headers: {
      [HEADER_SIMPLE_TOKEN]: simpleToken || "",
      [HEADER_USER_TOKEN]: userToken ?? "",
    },
    // @ts-expect-error: Flow to TS migration.
    method,
    query: queryPart,
    body: payload,
    retry,
  })
}
